import BaseRegulation from '../../base_regulation';
import {GNWP_SOURCES} from "../../../../../../../app-react/services/gnwp/gnwp-consts";

export default class CanadaOntarioRegulation extends BaseRegulation {
    static CLASS = 'CanadaOntarioRegulation';



    displayPopUpRatingAfterGame(): boolean {
        return false;
    }

    overrideCurrencySymbol(): string {
        return '$';
    }

    showNetPosition(): boolean {
        return true;
    }

    shouldCallCountryByIP(country:string) {
        return true;
    }

    fitToPlayModeEnabled(): boolean {
        return true;
    }

    showAgeResponsibleIconInGame() {
        return false;
    }

    showResponsibleIcons() {
        return true;
    }

    stepsBeforeOpenLoginAndRegistration():Promise<void> {
        return this.serviceFactory.orbitComponentRenderService().showLocationPopup({});
    }

    runConditionsBeforeOpenLink(source: string):Promise<void> {
        if(source !== GNWP_SOURCES.MEMBERSHIP) {
            return Promise.resolve();
        }

        return this.stepsBeforeOpenLoginAndRegistration();
    }


    private sendAnalytics(category:string, action:string):void {
        const analyticsData:any = {
            CGPEventCategory: category,
            CGPEventAction: action
        };

        this.logger.debug(action, JSON.stringify(analyticsData));
        this.serviceFactory.structuredLoggingService().getLogger(analyticsData).info();
    }
}